import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ICodeAndDescription, LookupCriteria } from "@tylertech/tyler-api-types";
@Injectable()
export class AlertCodeService
{
    private readonly $apiService = inject(ApiService);


    Lookup(pCriteria: LookupCriteria): Promise<ICodeAndDescription[]>
    {
        return this.$apiService.sendAuth("IAlertService/LookupAlert", pCriteria);
    }
}
